import {useCallback} from "react";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router";
import {syncTemplates} from "../../../redux/Actions/organizations.actions";

export const useOrganizationTableActions = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleActionSelection = useCallback(
    (action, data) => {
      switch (action) {
        case "Push_Templates":
          dispatch(syncTemplates({org_id: data.id}));
          break;
        case "View":
          navigate(`/app/organization/${data.id}`);
          break;
      }
    },
    [dispatch, navigate]
  );

  return {handleActionSelection};
};
